<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.orange" *ngIf="!showSubmitted">
  <mat-card-content>
    <div style="color: #303030" class="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-start items-start sm:items-center">
      <mat-icon class="medium-icon m-24">domain</mat-icon>
      <h2 class="f-s-20" *ngIf="!renewing">Apply For a Laboratory License</h2>
      <h2 class="f-s-20" *ngIf="renewing">Renew Laboratory License</h2>
      <h2 class="f-s-20 flex items-center gap-2" *ngIf="license.licenseId"> {{license.licenseId}}
        <button mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId)"
                matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
          <mat-icon>content_copy</mat-icon>
        </button>
      </h2>
      <span class="flex-1"></span>
      <button mat-flat-button color="primary"
      *ngIf="viewForm && !editingApplicant && !editingEntityApplicant && hasApplication" (click)="closeApplication()">Close</button>
    </div>
  </mat-card-content>
</mat-card>

<div *ngIf="viewForm && !showSubmitted" class="flex w-full flex-col gap-2" style="overflow-x: auto;">
  <mat-stepper class="readable-stepper" [orientation]="sharedService.isMobile? 'vertical' : 'horizontal'" #testingLabStepper
    [selectedIndex]="step" (selectionChange)="changeStep($event)">

    <!--Getting Started-->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Getting Started" matTooltipPosition="below" [matTooltipShowDelay]="500">Getting Started</span>
      </ng-template>
      <div class="p-b-8 flex flex-col gap-2">
        <mat-card >
          <mat-card-title>
            <span *ngIf="!renewing">Thank you for your interest in applying for a psilocybin laboratory license through the Oregon Psilocybin Services - Training Program,
              Licensing, and Compliance system (TLC). </span>
              <span *ngIf="renewing">Thank you for your interest in applying to renew your psilocybin laboratory license through the Oregon Psilocybin Services - Training Program, Licensing, and Compliance system (TLC).</span>
          </mat-card-title>
          <mat-card-content>
          <div style="padding-top: 1em" class="flex flex-col gap-2 f-s-16">
            <span class="p-l-24">
              <strong *ngIf="!renewing"><u>One applicant must be designated as the Primary Point of Contact for communication. The primary point of contact is
                responsible for ensuring all persons identified as licensees or applicants are aware of relevant communications, including but not limited to
                notices issued under ORS Chapter 183. </u></strong>
              <strong *ngIf="renewing"><u>One applicant must be designated as the Primary Point of Contact for communication. The primary point of contact is
                responsible for ensuring all persons identified as licensees or applicants are aware of relevant communications, including but not limited to
                notices issued under ORS Chapter 183. If the primary point of contact will be different upon renewal, please send this through the change request
                process. Change request process documents can be found on the TLC Home Page.</u></strong>
            </span>
            <span class="p-l-24">
              <strong><u>Applicants must read, understand, and agree to adhere to the Oregon Psilocybin Services
                Revised Statutes <a href="https://www.oregonlegislature.gov/bills_laws/ors/ors475a.html" target="_blank" rel="noreferrer noopener" style="
                white-space: normal;">(ORS) Chapter 475A</a>, Oregon Administrative Rules <a href="https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=7102"
                target="_blank" rel="noreferrer noopener" style="white-space: normal;">(OAR) Chapter 333</a>, Division 333, as well as
                any other applicable statutes or laws.</u></strong>
            </span>
            <strong *ngIf="!renewing">The completed application packet contains the following:</strong>
            <strong *ngIf="renewing">A completed renewal application packet contains the following: </strong>
            <ul class="flex flex-col gap-2 f-s-16">
              <li *ngIf="!renewing">
                Completed and signed laboratory license application
              </li>
              <li *ngIf="renewing">
                Completed and signed laboratory license renewal application
              </li>
              <li *ngIf="!renewing">
                Uploaded copy of the front and back of a valid, unexpired government-issued photo identification for the applicant(s)
              </li>
              <li>
                Uploaded individual and entity applicant information forms for each applicant
              </li>
              <li *ngIf="!renewing">
                Uploaded copy of ORELAP endorsement
              </li>
              <li *ngIf="!renewing">
                Uploaded sketch of premises, floor plan including boundaries, and camera plan
              </li>
              <li *ngIf="!renewing">
                Uploaded copy of the social equity plan
              </li>
              <li *ngIf="renewing">
                Uploaded evaluation of last year's Social Equity Plan
              </li>
              <li *ngIf="!renewing">
                <strong>$500</strong> Non-refundable laboratory license application fee paid and cleared.
              </li>
              <li>
                Uploaded copy of the <strong><i>front and back</i></strong> of a valid, unexpired government-issued photo identification
              </li>
            </ul>

            <strong>Important Notes: </strong>
            <ul class="flex flex-col gap-2 f-s-16">
              <li>
                Please review each section of the application to ensure it is complete
              </li>
              <li *ngIf="!renewing">
                Toward the end of the application, a fee page will describe how to submit the application fee which may be paid online or in-person
              </li>
              <li *ngIf="renewing">
                Toward the end of the renewal application, a fee page will describe how to submit the renewal license fee which may be paid online, by mail or in-person
              </li>
              <li *ngIf="!renewing">
                OPS will not review an application packet until the application fee is paid and cleared. You have 90 days from the date of
                application submission to pay the application fee or it will be closed.
              </li>
              <li *ngIf="!renewing">
                <strong>Incomplete and Insufficient Application Statuses:</strong>
              </li>
              <div style="padding-left: 1em" *ngIf="!renewing" class="flex flex-col">
                <li *ngIf="showNewIncompleteDates(license.applicationDate)">
                  Incomplete: An application is considered incomplete if the application is missing required information (e.g., the application fee has not been
                  paid or the applicant did not submit fingerprints). If the application is incomplete, we will notify you by email to give you an opportunity to make
                  your application complete. You have 30 days from the initial date you are notified to complete your application. If you fail to do so, the application will be closed.
                </li>
                <li *ngIf="showNewIncompleteDates(license.applicationDate)">
                  Insufficient: An application is considered insufficient if the complete application or site inspection does not meet requirements
                  outlined in statute or rule. If the application is insufficient, we will notify you by email to give you an opportunity to meet requirements. You will
                  have 30 days from the initial date you are notified to meet requirements, or your application will be denied.
                </li>
                <li *ngIf="!showNewIncompleteDates(license.applicationDate)">
                  Incomplete: An application is considered incomplete if the application is missing required information (e.g., the application fee has not been
                  paid or the applicant did not submit fingerprints). If the application is incomplete, we will notify you by email to give you an opportunity to make
                  your application complete. You have 90 days from the initial date you are notified to complete your application. If you fail to do so, the application will be closed.
                </li>
                <li *ngIf="!showNewIncompleteDates(license.applicationDate)">
                  Insufficient: An application is considered insufficient if the complete application or site inspection does not meet requirements
                  outlined in statute or rule. If the application is insufficient, we will notify you by email to give you an opportunity to meet requirements. You will
                  have 90 days from the initial date you are notified to meet requirements, or your application will be denied.
                </li>
              </div>
            </ul>

            <div *ngIf="renewing" class="flex flex-col gap-2">
              <strong>Renewal:</strong>
              <span class="p-l-24">
                <strong>Timely Renewal Applications:</strong>
              </span>
              <span class="p-l-24">
                To be considered a timely renewal under OAR 333-333, renewal applications must be complete, meet all submission requirements, and be submitted at
                least 60 days before the license expiration date. The TLC system will open 120 days before the license expires to allow licensees to apply for the renewal license.
              </span>
              <span class="p-l-24">
                If a timely application is submitted, licensees may continue to operate after the license expires, provided OPS has not yet processed the renewal. Incomplete
                renewal applications will not be considered timely unless all required information is submitted at least 60 days before the expiration date.
              </span>
              <span class="p-l-24">
                <strong>Important:</strong> If your renewal application fee does not clear 30 days after your renewal application is moved to “Renewal approved, pending
                fee payment and clearance” status, your renewal application will be closed. If your license has expired, you will no longer be able to exercise the privileges of the license upon expiration.
              </span>
              <span class="p-l-24">
                You are welcome to re-apply for an OPS license in the future through the TLC system or by mail. To re-apply, you will have to complete the application process, pay the
                application and license fee, and complete a new background check, along with all other requirements of licensure.
              </span>

              <span class="flex-1"></span>

              <span class="p-l-24">
                <strong>Untimely Renewal Applications:</strong>
              </span>
              <span class="p-l-24">
                Under OAR 333-333, any renewal applications submitted fewer than 60 days prior to the license expiration date are considered untimely.
              </span>
              <span class="p-l-24">
                Per ORS 333-333, licensees who submit untimely applications may not continue to operate if OPS is unable to process the untimely renewal before the license expires. In such
                cases, all licensed activities must cease as of the expiration date until the renewal is approved and a new license is issued.
              </span>
              <span class="p-l-24">
                <strong>Important:</strong> If your renewal payment does not clear within 30 days of your renewal application being moved to “Renewal approved, pending fee payment and clearance” status, your renewal application will be closed. If your license has expired, you will no longer be able to exercise the privileges of the license upon expiration.
              </span>
              <span class="p-l-24">
                You are welcome to re-apply for an OPS license in the future through the TLC system or by mail.
              </span>
              <span class="p-l-24">
                When the license expires, TLC-PTS (TLC product tracking system) access and records will be inaccessible. <strong>By 11:45 p.m. on the date of license expiration:</strong>
              </span>
              <ul class="flex flex-col gap-2 f-s-16" style="padding-left: 4em;">
                <li>
                  Operations must pause until the renewal is approved.
                </li>
                <li>
                  All products will need to have been transferred to another licensee or wasted.
                </li>
                <li>
                  TLC-PTS must be updated with transfers/wasted products.
                </li>
                <li>
                  Sales records and other documentation will need to be downloaded by licensees.
                </li>
              </ul>

              <span class="p-l-24">
                Upon approval of the renewal application, TLC-PTS will begin at zero. Previous TLC-PTS information will not transfer to the renewed license due to the disruption in
                licensure. To re-apply, you will have to complete the application process, pay the application and license fee, and complete a new background check, along with all other requirements of licensure.
              </span>
            </div>
            <span *ngIf="!renewing">
            <strong>When you click the continue button at the bottom of this page, you will proceed to the psilocybin laboratory license application. </strong>
              The application automatically saves in TLC. You may exit the application and come back later to complete and submit the application, if needed.
            </span>
            <span *ngIf="renewing">
              <strong>When you click the continue button at the bottom of this page, you will proceed to the psilocybin laboratory license renewal application.</strong>
              The renewal automatically saves in TLC. You may exit the application and come back later to complete and submit the renewal application, if needed.
              </span>
            <div style="padding-top: 2em;" class="flex flex-col gap-2">
              <span>
                <strong>DISCLAIMER:</strong> Psilocybin remains a schedule I drug under the federal Controlled Substances Act. Applicants are responsible for making their own determinations regarding the legal risks associated with participating in this program. The
                  information you provide in your application materials, including applicant name, is subject to disclosure under Oregon's public records laws.
              </span>
            </div>
          </div>
          </mat-card-content>
        </mat-card>

        <div *ngIf="!hasApplication && showStartButton">
          <button mat-flat-button type="button" color="primary" (click)="startApplication()">Start Application</button>
        </div>
        <div *ngIf="hasApplication" class="p-t-16 flex flex-row w-full md:w-1/2">
          <button mat-raised-button matStepperNext>Continue</button>
        </div>
      </div>
    </mat-step>

    <!--Testing Lab Information-->
    <mat-step *ngIf="licenses.length > 0">
      <ng-template matStepLabel>
        <span *ngIf="licenseForm.valid || licenseForm.pristine || licenseLocked"
          matTooltip="Laboratory Information" matTooltipPosition="below" [matTooltipShowDelay]="500">Laboratory Information</span>
        <span *ngIf="!licenseForm.valid && !licenseForm.pristine && !licenseLocked" class="text-red-400"
          matTooltip="Laboratory Information Incomplete" matTooltipPosition="below" [matTooltipShowDelay]="500">Laboratory Information Incomplete</span>
      </ng-template>

      <form [formGroup]="licenseForm">
        <div class="flex flex-col">
          <div class="flex flex-col lg:flex-row gap-2">
            <mat-card class="md:w-[40%] w-full">
              <mat-card-title>
                <span>Laboratory Information</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2">

                  <span id="operationalNameLabel" class="f-s-16"><strong>Operational Name</strong><span style="color: red" *ngIf="licenseForm.get('entityName').value ==''">*</span></span>
                  <mat-form-field>
                    <input matInput formControlName="entityName" aria-describedby="operationalNameLabel">
                    <mat-label style="color:red" *ngIf="licenseForm.get('entityName').value == ''">Operational Name*</mat-label>
                    <mat-label style="color:grey" *ngIf="licenseForm.get('entityName').value != ''">Operational Name</mat-label>
                    <mat-error role="alert" *ngIf="licenseForm.get('entityName').invalid">
                      Error: A name is required
                    </mat-error>
                  </mat-form-field>

                  <span class="f-s-16" *ngIf="sharedService.isAfterJan15th2027()"><strong>Assumed Business Name</strong></span>
                  <div class="flex flex-row gap-2 f-s-16" *ngIf="sharedService.isAfterJan15th2027()">
                    <div class="flex flex-col">
                    <span id="assumedBusiness" class="text-wrap">Is this operational name registered as an Assumed Business Name with the Secretary of State in Oregon?</span>
                    <mat-radio-group aria-label="Select an option" formControlName="assumedBusiness" aria-describedby="assumedBusiness" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateAssumedBusiness()">Error: This field is required</mat-error>
                  </div>
                  </div>
                  <div *ngIf="licenseForm.get('assumedBusiness').value == true && sharedService.isAfterJan15th2027()" [@slideInOut] class="flex flex-col gap-2 f-s-16">
                    <div class="flex flex-col">
                      <span id="assumedBusinessNumber">Oregon Secretary of State ABN Number</span>
                      <mat-form-field>
                        <input matInput placeholder="Oregon Secretary of State ABN Number" formControlName="assumedBusinessNumber" aria-describedby="assumedBusinessNumber">
                      </mat-form-field>
                      <mat-error role="alert" *ngIf="validateAssumedBusinessNumber()">
                        Error: Oregon Secretary of State ABN Number is required
                      </mat-error>
                    </div>
                  </div>

                  <span id="websiteLabel" class="f-s-16"><strong>Website</strong></span>
                  <mat-form-field>

                    <input matInput placeholder="Website" formControlName="entityWebsite" aria-describedby="websiteLabel">
                    <mat-error role="alert" *ngIf="licenseForm.get('entityWebsite').hasError('pattern')">
                      Error: Please enter a valid URL (http:// or https://)
                    </mat-error>
                  </mat-form-field>

                  <span class="f-s-16"><strong>Registered Business</strong></span>
                  <div class="flex flex-row gap-2 f-s-16">
                    <div class="flex flex-col">
                    <span id="businessInOregon" class="text-wrap">Is the applicant registered as a business with the Secretary of State (SOS) in Oregon?</span>
                    <mat-radio-group aria-label="Select an option" formControlName="businessInOregon" aria-describedby="businessInOregon" class="gap-2">
                      <mat-radio-button [value]="true" [disabled]="renewing"><span class="f-s-16">Yes</span> </mat-radio-button>
                      <mat-radio-button [value]="false" [disabled]="renewing"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateBusinessInOregon()">Error: This field is required</mat-error>
                  </div>
                  </div>
                  <div *ngIf="licenseForm.get('businessInOregon').value == true" [@slideInOut] class="flex flex-col gap-2 f-s-16">
                    <div class="flex flex-col">
                      <span id="sosNumberLabel">Oregon Secretary of State Registration Number</span>
                      <mat-form-field>
                        <input matInput placeholder="Registry Number" formControlName="secretaryofStateNumber" aria-describedby="sosNumberLabel">
                      </mat-form-field>
                      <mat-error role="alert" *ngIf="validateSecretaryofStateNumber()">
                        Error: Secretary of State Registration Number is required
                      </mat-error>
                    </div>
                  </div>
                  <div *ngIf="!licenseForm.get('businessInOregon').value" class="flex flex-row gap-2 f-s-16">
                    <div class="flex flex-col">
                    <span id="registeredBusiness" class="text-wrap">Is the applicant registered as a business in another state, US territory or a freely associated state?</span>
                    <mat-radio-group aria-label="Select an option" formControlName="registeredBusiness" aria-describedby="registeredBusiness" class="gap-2">
                      <mat-radio-button [value]="true" [disabled]="renewing"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false" [disabled]="renewing"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateBusinessInOtherState()">Error: This field is required</mat-error>
                  </div>
                  </div>
                  <div *ngIf="licenseForm.get('registeredBusiness').value == true && licenseForm.get('businessInOregon').value == false" [@slideInOut] class="flex flex-col gap-2 f-s-16">
                    <div class="flex flex-col">
                      <span id="registeredLocationLabel">Please provide the location (state, US territory, or freely associated state) where the laboratory is registered as a business and the registration number.</span>

                      <mat-form-field>
                        <input matInput placeholder="Location Registered" formControlName="registeredIn" aria-describedby="registeredLocationLabel">
                      </mat-form-field>
                      <mat-error role="alert" *ngIf="validateRegisteredLocation()">Error: Business Location is required</mat-error>

                      <mat-form-field>
                        <input matInput placeholder="Registration Number" formControlName="registryNumber" aria-describedby="registeredLocationLabel">
                      </mat-form-field>
                      <mat-error role="alert" *ngIf="validateRegistryNumber()">Error: Registration Number is required</mat-error>
                    </div>
                  </div>
                  <mat-checkbox formControlName="registrationAttestation">
                    <span [ngClass]="!licenseForm.get('registrationAttestation').value && licenseForm.get('registrationAttestation').touched? 'text-red-400' : ''"
                          class="text-wrap f-s-16"><strong *ngIf="!renewing">I understand licensees that are required to be registered with the Oregon Secretary of State must register prior
                            to receiving a license and maintain registration per OAR 333-333-4400 (11).</strong>
                            <strong *ngIf="renewing">I understand that applicants are required to be registered with the Oregon Secretary of State and must ensure they are still registered prior
                              to applying for a renewal and maintain registration per OAR 333-333-4400 (11).</strong></span>
                  </mat-checkbox>

                  <div class="flex flex-col gap-2">
                    <span class="f-s-16"><strong>Other OPS Licenses or Permits</strong></span>
                    <mat-checkbox formControlName="previousLicense">
                      <span class="text-wrap f-s-16">Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services</span>
                    </mat-checkbox>
                    <div *ngIf="this.licenseForm.get('previousLicense').value" [@slideInOut] class="flex flex-col">
                      <span id="affiliatedLicensesLabel">Please provide the license id(s) for each Oregon Psilocybin Services license</span>
                      <mat-form-field>
                        <input matInput formControlName="affiliatedLicenses" aria-describedby="affiliatedLicensesLabel">
                          <mat-label style="color:red" *ngIf="validatePreviousLicense()">Affiliated Licenses*</mat-label>
                        <mat-label style="color:grey" *ngIf="!validatePreviousLicense()">Affiliated Licenses</mat-label>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="md:w-[60%] w-full">
              <mat-card-title>
                <span>Laboratory Address</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <span id="physicalAddressLabel" class="f-s-16"><strong>Physical Address</strong><span style="color: red" *ngIf="licenseForm.get('physicalStreet').value == '' ||
                                                                                                          licenseForm.get('physicalCity').value == '' ||
                                                                                                          licenseForm.get('physicalZip').value == ''">*</span></span>
                  <div class="flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full md:w-[30%]">
                      <input matInput formControlName="physicalStreet" aria-describedby="physicalAddressLabel">
                      <mat-label style="color:red" *ngIf="licenseForm.get('physicalStreet').value == ''">Street Apt/Unit/Suite*</mat-label>
                      <mat-label style="color:grey" *ngIf="licenseForm.get('physicalStreet').value != ''">Street Apt/Unit/Suite</mat-label>
                      <mat-error role="alert" *ngIf="licenseForm.get('physicalStreet').invalid">
                        Error: Please provide a street
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[30%]">
                      <input matInput formControlName="physicalCity" aria-describedby="physicalAddressLabel">
                      <mat-label style="color:red" *ngIf="licenseForm.get('physicalCity').value == ''">City*</mat-label>
                      <mat-label style="color:grey" *ngIf="licenseForm.get('physicalCity').value != ''">City</mat-label>
                      <mat-error role="alert" *ngIf="licenseForm.get('physicalCity').invalid">
                        Error: Please provide a city
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="State" value="OR" disabled>
                    </mat-form-field>
                  </div>

                  <div class="m-b-8 flex flex-col md:flex-row gap-4">
                    <mat-form-field class="w-full md:w-[20%]">
                      <input matInput formControlName="physicalZip" aria-describedby="physicalAddressLabel">
                      <mat-label style="color:red" *ngIf="licenseForm.get('physicalZip').value == ''">Zip*</mat-label>
                      <mat-label style="color:grey" *ngIf="licenseForm.get('physicalZip').value != ''">Zip</mat-label>
                      <mat-error role="alert" *ngIf="licenseForm.get('physicalZip').hasError('required')">
                        Error: Please provide a zipcode
                      </mat-error>
                      <mat-error role="alert" *ngIf="licenseForm.get('physicalZip').hasError('pattern')">
                        Error: Zipcode should match this format: 99999 or 99999-1234
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[20%]">
                      <mat-label style="color:red" *ngIf="licenseForm.get('physicalCounty').value == ''">County*</mat-label>
                      <mat-label style="color:grey" *ngIf="licenseForm.get('physicalCounty').value != ''">County</mat-label>
                      <mat-select formControlName="physicalCounty" aria-describedby="physicalAddressLabel">
                        <mat-option [disabled]="renewing">-- None --</mat-option>
                        <mat-option [disabled]="renewing" *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                      </mat-select>
                      <mat-error role="alert" *ngIf="licenseForm.get('physicalCounty').hasError('required')">
                        Error: Please provide a county
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <span id="premisesDescLabel" class="f-s-16">Please provide a brief description of the premises</span>
                  <div>
                    <mat-form-field class="w-[75%]">
                      <textarea matInput placeholder="Describe the Premises" cols="2" formControlName="premisesDescription" aria-describedby="premisesDescLabel"></textarea>
                    </mat-form-field>
                  </div>
                </div>

                <div class="m-t-8 flex flex-col">
                  <div class="flex flex-col md:flex-row gap-6">
                    <span id="mailingAddressLabel" class="f-s-16"><strong>Mailing Address</strong><span style="color: red" *ngIf="validateMailingStreet()">*</span></span>
                    <mat-checkbox formControlName="mailingIsPhysical" (change)="mailingIsSame()">
                      Same as Physical
                    </mat-checkbox>
                  </div>
                  <div [@slideInOut] *ngIf="!licenseForm.get('mailingIsPhysical').value" class="flex flex-col">
                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full md:w-[50%]">
                        <input matInput formControlName="mailingStreet"
                          (blur)="validateMailingStreet()" aria-describedby="mailingAddressLabel">
                          <mat-label style="color:red" *ngIf="licenseForm.get('mailingStreet').value == ''">Street Apt/Unit/Suite*</mat-label>
                        <mat-label style="color:grey" *ngIf="licenseForm.get('mailingStreet').value != ''">Street Apt/Unit/Suite</mat-label>
                        <mat-error role="alert" *ngIf="validateMailingStreet()">
                          Error: Please provide a street
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field class="w-full md:w-[50%]">
                        <input matInput formControlName="mailingCity" (blur)="validateMailingCity()" aria-describedby="mailingAddressLabel">
                        <mat-label style="color:red" *ngIf="licenseForm.get('mailingCity').value == ''">City*</mat-label>
                        <mat-label style="color:grey" *ngIf="licenseForm.get('mailingCity').value != ''">City</mat-label>
                        <mat-error role="alert" *ngIf="validateMailingCity()">
                          Error: Please provide a city
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full">
                        <mat-label style="color:red" *ngIf="licenseForm.get('mailingState').value == ''">State/US territory/freely associated state*</mat-label>
                        <mat-label *ngIf="licenseForm.get('mailingState').value != ''">State/US territory/freely associated state</mat-label>
                        <mat-select formControlName="mailingState" (blur)="validateMailingState()" aria-describedby="mailingAddressLabel">
                          <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                        </mat-select>
                        <mat-error role="alert" *ngIf="validateMailingState()">
                          Error: Please provide a state, US territory or freely associated state
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full md:w-[20%]">
                        <input matInput formControlName="mailingZip" (blur)="validateMailingZip()" aria-describedby="mailingAddressLabel">
                        <mat-label style="color:red" *ngIf="licenseForm.get('mailingZip').value == ''">Zip*</mat-label>
                      <mat-label style="color:grey" *ngIf="licenseForm.get('mailingZip').value != ''">Zip</mat-label>
                        <mat-error role="alert" *ngIf="validateMailingZip()">
                          Error: Please provide a zipcode
                        </mat-error>
                        <mat-error role="alert" *ngIf="licenseForm.get('mailingZip').hasError('pattern')">
                          Error: Zipcode should match this format: 99999 or 99999-1234
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="licenseForm.get('mailingState').value === 'OR'" class="w-full md:w-[20%]">
                        <mat-label style="color:red" *ngIf="licenseForm.get('mailingCounty').value == ''">County*</mat-label>
                      <mat-label *ngIf="licenseForm.get('mailingCounty').value != ''">County</mat-label>
                        <mat-select formControlName="mailingCounty" aria-describedby="mailingAddressLabel">
                          <mat-option>-- None --</mat-option>
                          <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div *ngIf="renewing" class="flex flex-row">

          <mat-card class="flex flex-col gap-2">
            <div class="flex flex-row">
                <div class="flex flex-col gap-2">
                  <span class="text-wrap" [ngClass]="licenseForm.get('testingLabInformationCorrect').value !== true && licenseForm.get('testingLabInformationCorrect').value !== false? 'text-red-400' : ''">Is all the information on this screen current and correct?</span>
                  <span id="testingLabInformationCorrect" class="text-wrap">Some information may be outdated or incorrect but you cannot change it on this application.
                    These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                    If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
                  <mat-radio-group aria-label="Select an option" formControlName="testingLabInformationCorrect" aria-describedby="testingLabInformationCorrect" class="gap-2">
                    <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                    <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                  </mat-radio-group>
                  <mat-error role="alert" *ngIf="licenseForm.get('testingLabInformationCorrect').hasError('required')">Error: This field is required</mat-error>
                </div>
            </div>

            <div *ngIf="licenseForm.get('testingLabInformationCorrect').value == false" class="flex flex-row">
              <div class="flex flex-col md:w-[40%] w-full">
                <mat-form-field>
                  <textarea rows="2" matInput placeholder="Please list the information that is not current and correct" formControlName="testingLabInformationCorrectReason" aria-describedby="testingLabInformationCorrect"></textarea>
                  <mat-error role="alert" *ngIf="validateTestingLabInformationCorrect()">
                    Error: This field is required
                  </mat-error>
                 </mat-form-field>
                 <span>You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
              </div>
            </div>
          </mat-card>
        </div>
      </form>

      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>{{!licenseLocked? "Save and " : ""}}Back</button>
        <button mat-raised-button matStepperNext>{{!licenseLocked? "Save and " : ""}}Continue</button>
      </div>
    </mat-step>

    <!--Applicant Information-->
    <mat-step *ngIf="licenses.length > 0">
      <ng-template matStepLabel>
        <span *ngIf="(applicantsValid && entityApplicantsValid && contactValid && applicantAttestationValid) || licenseLocked"
              matTooltip="Applicant Information"
              matTooltipPosition="below"
              [matTooltipShowDelay]="500">Applicant Information</span>
        <span *ngIf="(!applicantsValid || !entityApplicantsValid || !contactValid || !applicantAttestationValid) && !licenseLocked"
              class="text-red-400"
              matTooltip="Applicant Information Incomplete"
              matTooltipPosition="below"
              [matTooltipShowDelay]="500">Applicant Information Incomplete</span>
      </ng-template>

      <div class="flex flex-col lg:flex-row gap-2">
        <mat-card *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut] class="md:w-1/2 w-full">
          <mat-card-title>
            <span>Manage Applicants</span>
          </mat-card-title>
          <mat-card-content class="f-s-16">
            <span *ngIf="!renewing"><strong>An application for a psilocybin laboratory license must identify all individuals and legal entities who qualify
              as applicants as described in OAR 333-333-1010 and OAR 333-333-4030. Applicants are responsible for ensuring all individuals and
              legal entities who meet the definition of an applicant are identified.</strong></span>
            <span *ngIf="renewing"><strong>A renewal application for a psilocybin laboratory license must identify all individuals and legal entities who qualify
              as applicants as described in OAR 333-333-1010 and OAR 333-333-4030. Applicants are responsible for ensuring all individuals and legal entities who
              meet the definition of an applicant are identified. </strong></span>
              <div style="padding-top: 1em" class="flex flex-col gap-2">
                <span><strong>Applicants are individuals or legal entities who:</strong></span>
                <ul class="flex flex-col gap-2 f-s-16">
                  <li>
                    Hold or control an interest of more than 20 percent in the entity proposed to be licensed;
                  </li>
                  <li>
                    Are entitled to receive 20 percent or more of revenue, profits or proceeds from the entity proposed to be licensed; or
                  </li>
                  <li>
                    Are entitled to exercise control over the entity proposed to be licensed.
                  </li>
                </ul>
              </div>

              <div style="padding-top: 1em" class="flex flex-col gap-2">
                <span><strong>If a legal entity is an applicant, the following individuals within the legal entity are also
                  applicants:</strong></span>
                <ul class="flex flex-col gap-2 f-s-16">
                  <li>
                    If an applicant is a limited partnership, each general partner in the limited partnership.
                  </li>
                  <li>
                    If an applicant is a limited liability company, each manager and managing member of the limited liability company.
                  </li>
                  <li>
                    If the applicant is a for-profit corporation, each principal officer of the corporation.
                  </li>
                  <li>
                    If the applicant is a non-profit entity, each principal officer of the entity.
                  </li>
                  <li>
                    Any individual within the legal entity who meets the definition of applicant in OAR 333-333-1010.
                  </li>
                </ul>
              </div>

              <div style="padding-top: 1em" class="flex flex-col gap-2">
                <span><strong>Guidance for entering applicants on this screen</strong></span>
                <ul class="flex flex-col gap-2 f-s-16">
                  <li>
                    All applicants must be entered on this screen
                  </li>
                  <li>
                    If an individual within a legal entity is identified as an applicant, please add
                  them as an individual applicant
                  </li>
                </ul>
              </div>

              <div style="padding-top: 1em" class="flex flex-col gap-2">
                <span><strong>Individual and Legal Entity Applicant Information Forms</strong></span>
                <span class="p-l-24">
                  Each individual and legal entity applicant must complete an applicant information form where they will provide their applicant information,
                  agree to be added as an applicant to the application, agree to the designated point of contact for the application, and complete attestations.
                  Applicants are responsible for completing and ensuring all applicant information forms are uploaded on the Applicant Information tab,
                  in the Individual Applicants and/or Entity Applicants sections. Individual and legal entity applicant information forms can be found on the
                  <a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Pages/Psilocybin-License-Lab-Testing.aspx" target="_blank" rel="noreferrer noopener" style="word-break: break-all;
                  white-space: normal;">Oregon Psilocybin Services - Apply for a Laboratory License webpage.</a>.
                </span>
              </div>

              <form [formGroup]="licenseForm" style="padding-top: 1em">
                <div class="flex flex-col gap-2">
                  <mat-checkbox formControlName="applicantFeeAttestation">
                    <span [ngClass]="!licenseForm.get('applicantFeeAttestation').value &&
                                     !applicantAttestationValid? 'text-red-400' : ''"
                          class="text-wrap f-s-16">
                      <strong >I understand Oregon Psilocybin Services will charge a change fee of $250 per applicant for any change
                        to a previously approved license that results in the addition of an applicant. This change fee applies regardless of whether the licensee
                        requests the change at renewal or during the term of their license.</strong></span>
                  </mat-checkbox>

                  <mat-checkbox formControlName="applicantDenialAttestation">
                    <span [ngClass]="!licenseForm.get('applicantDenialAttestation').value &&
                                     !applicantAttestationValid? 'text-red-400' : ''"
                          class="text-wrap f-s-16">
                      <strong>I understand Oregon Psilocybin Services may deny an application if a person identified as an applicant for
                        the entity proposed to be licensed does not meet the definition of applicant in OAR 333-333-1010; or a person who meets the definition of
                        applicant in OAR 333-333-1010 has not been disclosed on the application.</strong></span>
                  </mat-checkbox>
                  <div *ngIf="renewing" class="flex flex-row">
                    <mat-card class="flex flex-col gap-2">
                      <div class="flex flex-row">
                          <div class="flex flex-col gap-2">
                            <span class="text-wrap" [ngClass]="licenseForm.get('applicantsCorrect').value != false && licenseForm.get('applicantsCorrect').value != true? 'text-red-400' : ''">Is all the information on this screen current and correct, including the applicants listed?</span>
                            <span id="applicantsCorrect" class="text-wrap">Some information may be outdated or incorrect but you cannot change it on this application.
                              These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                              If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
                            <mat-radio-group aria-label="Select an option" formControlName="applicantsCorrect" aria-describedby="applicantsCorrect" class="gap-2">
                              <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                              <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                            </mat-radio-group>
                            <mat-error role="alert" *ngIf="licenseForm.get('applicantsCorrect').hasError('required')">Error: This field is required</mat-error>
                          </div>
                      </div>
                      <div *ngIf="licenseForm.get('applicantsCorrect').value == false" class="flex flex-row">
                        <div class="flex flex-col">
                          <mat-form-field>
                            <textarea rows="2" matInput placeholder="Please list the information that is not current and correct" formControlName="applicantsCorrectReason" aria-describedby="applicantsCorrect"></textarea>
                          </mat-form-field>
                           <span role="alert" *ngIf="!licenseForm.get('applicantsCorrect').value && (licenseForm.get('applicantsCorrectReason').value == '' || licenseForm.get('applicantsCorrectReason').value == null)" style="color:red">
                            Error: This field is required
                          </span>
                           <span>You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
                        </div>
                      </div>
                    </mat-card>
                  </div>
                </div>
              </form>

          </mat-card-content>
        </mat-card>

        <div class="flex flex-col gap-4" [ngClass]="!editingApplicant && !editingEntityApplicant ? 'md:w-1/2 w-full' : 'w-full'">
          <mat-card *ngIf="!editingApplicant && !editingEntityApplicant" [@slideInOut]>
            <mat-card-title>
              <span *ngIf="contactValid">Primary Point of Contact</span>
              <span class="text-red-400" *ngIf="!contactValid">Primary Point of Contact Incomplete</span>
            </mat-card-title>
            <mat-card-content>
              <div class="flex flex-col gap-2">

                <div class="flex flex-col md:flex-row gap-2">
                  <div class="flex flex-col w-full md:w-1/2 f-s-16">
                    <span class="f-s-16"><strong>Contact Name</strong></span>
                    {{license.primaryContactName}}
                  </div>
                  <div class="flex flex-col w-full md:w-1/2 f-s-16">
                    <span class="f-s-16"><strong>Contact Phone</strong></span>
                    {{license.primaryContactNumber | mask: '(000) 000-0000 000000'}}
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2">
                  <div class="flex flex-col w-full md:w-1/2 f-s-16">
                    <span class="f-s-16"><strong>Email Address</strong></span>
                    <span>{{license.primaryContactEmail}}</span>
                  </div>
                  <div class="flex flex-col w-full md:w-1/2 f-s-16">
                    <span class="f-s-16"><strong>Preferred Language</strong></span>
                    <span>{{license.language}}</span>
                  </div>
                </div>

              </div>
            </mat-card-content>
          </mat-card>

          <app-applicant *ngIf="license.id > 0" [@slideInOut] [ngStyle]="{'display': !editingEntityApplicant? '' : 'none'}" [licenseId]="license.id" [status]="license.status" [licenseType]="sharedService.testingLab" [documentTypes]="documentTypes" [primaryContactId]="license.primaryContactId" tableColor="orange" [renewal]="renewing" (notifyParent)="editApplicant($event)" (setPointOfContact)="setPointOfContact($event)" [cardColor]="cardColor" [licenseLocked]="licenseLocked">
          </app-applicant>
          <app-entity-applicant *ngIf="!editingApplicant && license.id > 0" [@slideInOut] [licenseId]="license.id" [status]="license.status" [licenseType]="sharedService.testingLab" tableColor="orange" [renewal]="renewing" [cardColor]="cardColor" [documentTypes]="documentTypes" [licenseLocked]="licenseLocked" [individualApplicants]="individualApplicants?.applicants" (notifyParent)="editEntityApplicant($event)">
          </app-entity-applicant>
        </div>
      </div>

      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button *ngIf="!editingApplicant && !editingEntityApplicant" mat-raised-button matStepperPrevious>{{!licenseLocked? "Save and " : ""}}Back</button>
        <button *ngIf="!editingApplicant && !editingEntityApplicant" mat-raised-button matStepperNext>{{!licenseLocked? "Save and " : ""}}Continue</button>
      </div>
    </mat-step>

    <!--Financial Interest-->
    <mat-step *ngIf="licenses.length > 0">
      <ng-template matStepLabel>
        <span *ngIf="financialAttestationValid || licenseLocked"
              matTooltip="Financial Interest"
              matTooltipPosition="below"
              [matTooltipShowDelay]="500">Financial Interest</span>
        <span *ngIf="!financialAttestationValid && !licenseLocked"
              matTooltip="Financial Interest Incomplete"
              matTooltipPosition="below"
              [matTooltipShowDelay]="500"
              class="text-red-400">Financial Interest Incomplete</span>
      </ng-template>

      <mat-card>
        <mat-card-title>
          <span>Financial Interest Disclosures</span>
        </mat-card-title>
        <mat-card-content>
          <div style="padding-top: 1em" class="flex flex-col gap-2 f-s-16 ">
            <span><strong>Restriction on financial interests on multiple licenses (ORS 475A.280)</strong></span>
            <span>An individual may not have a financial interest in:</span>
            <ul class="flex flex-col gap-2 f-s-16">
              <li>More than one psilocybin product manufacturer; or;</li>
              <li>More than five psilocybin service center operators</li>
            </ul>

            <span><strong>Financial Interests (OAR 333-333-4040)</strong></span>
            <span>Applicants and licensees must create and maintain complete lists of all individuals and legal
              entities that hold a financial interest in the laboratory, including contact information for each individual
              or entity and a description of their financial interest. Applicants and licensees must provide the information
              required by this section to Oregon Psilocybin Services within 15 calendar days of the written request for such information.
              </span>

              <span><strong>If a legal entity holds a financial interest, the following individuals within the legal entity also hold a financial interest:</strong></span>
              <ul class="flex flex-col gap-2 f-s-16">
                <li>For limited partnerships, each general partner in the limited partnership.</li>
                <li>For limited liability companies, each manager and managing member of the limited liability	company.</li>
                <li>For for-profit corporations, each principal officer of the corporation.</li>
                <li>For non-profit entities, each principal officer of the entity.</li>
              </ul>

            <form [formGroup]="licenseForm" style="padding-top: 1em">
              <div class="flex flex-col gap-3">
                <div class="flex flex-row">
                  <mat-checkbox formControlName="financialAttestation">
                    <span [ngClass]="!licenseForm.get('financialAttestation').value &&
                                 !financialAttestationValid? 'text-red-400' : ''"
                      class="text-wrap f-s-16"><strong>I have read, understand, and agree to adhere to the financial interest requirements outlined in ORS 475A and OAR, Chapter 333.
                        I understand every individual and legal entity applicant in the proposed laboratory to be licensed must comply with the requirements of ORS 475A.280, Restriction on
                        financial interests in multiple licenses. I understand Oregon Psilocybin Services shall deny an application for a laboratory license if an individual or legal entity that holds a
                        financial interest in the entity proposed to be licensed holds a financial interest in five or more service center licenses.</strong></span>
                  </mat-checkbox>
                </div>
                <div *ngIf="renewing" class="flex flex-row">

                  <mat-card class="flex flex-col gap-2">
                    <div class="flex flex-row">
                        <div class="flex flex-col gap-2">
                          <span class="text-wrap f-s-16" [ngClass]="licenseForm.get('financialInterestCorrect').value !== true && licenseForm.get('financialInterestCorrect').value !== false? 'text-red-400' : ''">Is all the information on this screen current and correct?</span>
                          <span id="financialInterestCorrect" class="text-wrap f-s-16">Some information may be outdated or incorrect but you cannot change it on this application.
                            These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                            If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
                          <mat-radio-group aria-label="Select an option" formControlName="financialInterestCorrect" aria-describedby="financialInterestCorrect" class="gap-2">
                            <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                            <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                          </mat-radio-group>
                          <mat-error role="alert" *ngIf="licenseForm.get('financialInterestCorrect').hasError('required')">Error: This field is required</mat-error>
                        </div>
                    </div>

                    <div *ngIf="licenseForm.get('financialInterestCorrect').value == false" class="flex flex-row">
                      <div class="flex flex-col w-[40%]">
                        <mat-form-field>
                          <textarea rows="2" matInput placeholder="Please list the information that is not current and correct" formControlName="financialInterestCorrectReason" aria-describedby="financialInterestCorrect"></textarea>
                          <span role="alert" class="f-s-12" style="color: red" *ngIf="!validateFinancialInterestCorrect()">
                            Error: This field is required*
                          </span>
                         </mat-form-field>
                         <span>You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
                      </div>
                    </div>
                  </mat-card>
                </div>
              </div>
            </form>
          </div>
        </mat-card-content>
      </mat-card>

      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>{{!licenseLocked? "Save and " : ""}}Back</button>
        <button mat-raised-button matStepperNext>{{!licenseLocked? "Save and " : ""}}Continue</button>
      </div>
    </mat-step>

    <!--Documents-->
    <mat-step *ngIf="licenses.length > 0">
      <ng-template matStepLabel>
        <span *ngIf="documentsValid || licenseLocked" matTooltip="Documents" matTooltipPosition="below" [matTooltipShowDelay]="500">Documents</span>
        <span *ngIf="!documentsValid && !licenseLocked" class="text-red-400"
          matTooltip="Documents Incomplete" matTooltipPosition="below" [matTooltipShowDelay]="500">Documents Incomplete</span>
      </ng-template>

      <form [formGroup]="documentsForm">
        <div class="flex flex-col gap-2">
          <div class="flex flex-col lg:flex-row">
            <mat-card class="w-full">
              <mat-card-title *ngIf="!renewing">
                The following documentation is required to apply for a Psilocybin Laboratory License
              </mat-card-title>
              <mat-card-title *ngIf="renewing">
                Upload the Following Documentation to apply for a Psilocybin Laboratory License
              </mat-card-title>
              <mat-card-content>
                <div class="p-b-8 flex flex-col gap-2 f-s-16" *ngIf="!renewing">
                  <ul class="flex flex-col gap-2">
                    <li>ORELAP Accreditation</li>
                    <li>Premises Plan Including Boundaries and Camera Plan</li>
                    <li>Social Equity Plan</li>
                    <li>Proposed Premises Pictures</li>
                  </ul>
                </div>
                <div class="p-b-8 flex flex-col gap-2 f-s-16" *ngIf="renewing">
                  <ul class="flex flex-col gap-2">
                    <li>Social Equity Plan Evaluation</li>
                    <li>Updated Social Equity Plan (not required)</li>
                    <li>ORELAP Accreditation (not required)</li>
                    <li>Premises Plan Including Boundaries and Camera Plan (not required)</li>
                    <li>Updated premises pictures (not required at this time but will be required before renewal site inspection)</li>
                  </ul>

                </div>
                <div style="padding-bottom: 1em" *ngIf="!renewing" class="flex flex-col gap-2 f-s-16 ">
                  <span><strong>Proposed Premises Pictures</strong></span>
                  <div class="flex flex-col gap-2">
                    <span>Laboratories must upload pictures of their proposed premises as part of their application. Pictures submitted must clearly show the following:</span>
                    <ul class="flex flex-col gap-2">
                      <li>All ingress and egress of a proposed licensed premises</li>
                      <li>Psilocybin secure storage area</li>
                      <li>Psilocybin secure waste storage</li>
                      <li>All limited access areas</li>
                      <li>Client administration area</li>
                      <li>Outdoor areas included on proposed premises</li>
                      <li>Secured storage of video surveillance equipment (not fixed cameras)</li>
                      <li>All four internal corners of the proposed premises</li>
                      <li>All four external corners of the proposed premises</li>
                    </ul>

                    <span>Please include additional pictures of any areas that are potentially hazardous, unsafe, or may not meet rules requirements.
                      Submitting a complete catalog of pictures will ensure we are able to review your proposed premises in a timely manner and work with you to make any potentially necessary changes.</span>
                    <span style="padding-left: 1em"><strong>* </strong>Pictures may be submitted after initial submission of application but are required prior to scheduling a site inspection</span>
                    <span style="padding-left: 1em"><strong>** </strong>Do not include any people in your pictures</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="flex flex-col md:flex-row gap-4 w-full">
            <mat-card class="w-full lg:w-1/2">
              <mat-card-title>
                Upload Supporting Documents
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <span class="f-2-14">For each document select the requirements it verifies</span>
                  <div class="p-t-8 flex flex-col gap-2">

                    <div class="flex flex-col">
                      <mat-checkbox formControlName="orelap" [ngStyle]="{ 'opacity': renewing && !missingTypes[orelapType] ? 0.5 : 1 }">
                        <span class="text-wrap f-s-16"
                              [ngClass]="!documentsValid && missingTypes[orelapType] ? 'text-red-400' : ''">
                          ORELAP Accreditation
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="premisesSketch" [ngStyle]="{ 'opacity': renewing && !missingTypes[premisesType] ? 0.5 : 1 }">
                        <span class="text-wrap f-s-16"
                              [ngClass]="!documentsValid && missingTypes[premisesType] ? 'text-red-400' : ''">
                          Premises Plan Including Boundaries and Camera Plan
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="premisePicture" [ngStyle]="{ 'opacity': renewing && !missingTypes[premisePictureType] ? 0.5 : 1 }" *ngIf="!renewing">
                        <span class="text-wrap f-s-16"
                          [ngClass]="!documentsValid && missingTypes[premisePictureType] ? 'text-red-400' : ''">
                          Proposed Premises Pictures
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="socialEquityPlan" *ngIf="!renewing">
                        <span class="text-wrap f-s-16"
                              [ngClass]="!documentsValid && missingTypes[socialEquityType] ? 'text-red-400' : ''">
                          Social Equity Plan
                        </span>
                      </mat-checkbox>


                      <mat-checkbox formControlName="updatedEquityPlan" *ngIf="renewing">
                        <span class="text-wrap f-s-16" [ngClass]="!documentsValid && missingTypes[updatedEquityPlanType]? 'text-red-400' : ''">
                          Updated Social Equity Plan
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="equityPlanEvaluation" *ngIf="renewing">
                        <span class="text-wrap f-s-16" [ngClass]="!documentsValid && missingTypes[equityPlanEvaluationType]? 'text-red-400' : ''">
                          Social Equity Plan Evaluation
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="updatedPremisePicture" *ngIf="renewing">
                        <span class="text-wrap f-s-16" [ngClass]="!documentsValid && missingTypes[updatedPremisePictureType]? 'text-red-400' : ''">
                          Updated premises pictures
                        </span>
                      </mat-checkbox>
                    </div>

                    <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp,.mp4" class="file-input" (change)="uploadLicenseDocument($event)" #fileUpload />
                    <div class="flex flex-row gap-2">
                      <div class="file-upload">
                        <button [disabled]="!documentsForm.get('premisesSketch').value &&
                                            !documentsForm.get('orelap').value &&
                                            !documentsForm.get('socialEquityPlan').value &&
                                            !documentsForm.get('premisePicture').value &&
                                            !documentsForm.get('updatedEquityPlan').value &&
                                            !documentsForm.get('equityPlanEvaluation').value &&
                                            !documentsForm.get('updatedPremisePicture').value"
                                mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()">
                          Browse
                          <mat-icon>attach_file</mat-icon>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="w-full lg:w-1/2">
              <mat-card-title>
                <span>Current Documents</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <div *ngIf="!sharedService.mobile" class="flex flex-row md:items-center">
                    <div class="flex w-full md:w-1/2">
                      <span class="f-s-16"><strong>File</strong></span>
                    </div>
                    <div class="flex w-full md:w-1/2 md:flex-row md:items-center md:justify-between">
                      <div class="flex flex-col md:w-[70%]">
                        <span class="f-s-16"><strong>Requirement</strong></span>
                      </div>
                      <div class="flex items-center justify-end">
                      </div>
                    </div>
                  </div>
                  <div *ngFor="let document of this.license.licenseDocuments" class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                    <div class="flex w-full flex-col md:w-1/2">
                      <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                      <span class="w-full break-words text-indigo-A700" style="cursor: pointer" (click)="downloadDocument(document.id, document.name)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                    </div>
                    <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">


                      <div class="flex flex-col break-words md:w-[70%]">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                        <span *ngFor="let type of document.types">
                          {{documentTypeReference[type]}}
                        </span>
                      </div>


                      <div class="flex items-center justify-start md:justify-end">
                        <button *ngIf="!licenseLocked" type="button" mat-icon-button class="m-8" (click)="deleteFile(document.id, document.name)"
                          color="warn" aria-label="Delete">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </form>

      <div class="p-t-16 flex flex-row gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>Back</button>
        <button mat-raised-button matStepperNext>Continue</button>
      </div>
    </mat-step>

    <!--Fees-->
    <mat-step *ngIf="licenses.length > 0">
      <ng-template matStepLabel>
        <span matTooltip="Fee Information" matTooltipPosition="below" [matTooltipShowDelay]="500">Fee Information</span>
      </ng-template>
      <div class="flex flex-col gap-2 w-full lg:w-1/2">
        <span *ngIf="sharedService.tablet" class="f-s-18">Fees</span>
        <app-payment-notice [canPay]="false" entityType="TestingLabLicense" feeType="ApplicationFee" [renewal]="renewing"></app-payment-notice>
        <div class="flex flex-row gap-2 w-full md:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button matStepperNext>Continue</button>
        </div>
      </div>
    </mat-step>

    <!--Review-->
    <mat-step *ngIf="licenses.length > 0">
      <ng-template matStepLabel>
        <span matTooltip="Review and Submit" matTooltipPosition="below" [matTooltipShowDelay]="500">Review and Submit</span>
      </ng-template>

      <div class="flex flex-col">
        <div class="flex flex-col md:flex-row gap-2">
          <mat-card class="w-full md:w-1/2">
            <mat-card-title>
              <span *ngIf="licenseForm.valid || licenseForm.disabled">Laboratory Information</span>
              <span *ngIf="!licenseForm.valid && !licenseForm.disabled" class="text-red-400">Laboratory Information Incomplete</span>
            </mat-card-title>
            <mat-card-content>
              <div class="flex flex-col gap-2">
                <div class="flex flex-col 2xl:flex-row">
                  <span class="w-full lg:w-[30%] f-s-16">
                    <strong>Operational Name</strong>
                  </span>
                  <span class="w-full lg:w-[70%] break-words f-s-16">
                    {{license.entityName}}
                  </span>
                </div>
                <div class="flex flex-col 2xl:flex-row">
                  <span class="w-full lg:w-[30%] f-s-16">
                    <strong>Website</strong>
                  </span>
                  <span class="w-full lg:w-[70%] break-all f-s-16">
                    {{license.entityWebsite}}
                  </span>
                </div>
                <span class="text-red-400 f-s-16" *ngIf="!contactValid">Primary Contact is Required</span>
                <div class="flex flex-col 2xl:flex-row">
                  <span class="w-full lg:w-[30%] f-s-16">
                    <strong>Primary Contact</strong>
                  </span>
                  <span class="w-full lg:w-[70%] break-words f-s-16">
                    {{license.primaryContactName}}
                  </span>
                </div>
                <div class="flex flex-col 2xl:flex-row">
                  <span class="w-full lg:w-[30%] f-s-16">
                    <strong>Contact Phone</strong>
                  </span>
                  <span class="w-full lg:w-[70%] break-words f-s-16">
                    {{license.primaryContactNumber | mask: '(000) 000-0000 000000'}}
                  </span>
                </div>
                <div class="flex flex-col 2xl:flex-row">
                  <span class="w-full lg:w-[30%] f-s-16">
                    <strong>Contact Email</strong>
                  </span>
                  <span class="w-full lg:w-[70%] break-all f-s-16">
                    {{license.primaryContactEmail}}
                  </span>
                </div>
                <div class="flex flex-col 2xl:flex-row">
                  <span class="w-full lg:w-[30%] f-s-16">
                    <strong>Preferred Language</strong>
                  </span>
                  <span class="w-full lg:w-[70%] break-words f-s-16">
                    {{license.language}}
                  </span>
                </div>


                  <div class="flex flex-col 2xl:flex-row">
                    <span class="w-full lg:w-[30%] f-s-16"><strong>Headquarters Address</strong></span>
                    <span class="w-full lg:w-[70%] break-words f-s-16">
                      {{license.physicalStreet}}&nbsp;
                      {{license.physicalCity}}&nbsp;
                      {{license.physicalState}}&nbsp;
                      {{license.physicalZip}}&nbsp;
                      {{license.physicalCounty}}
                    </span>
                  </div>
                  <span class="f-s-16">{{license.premisesDescription}}</span>
                  <div class="flex flex-col 2xl:flex-row">
                    <span class="w-full lg:w-[30%] f-s-16"><strong>Mailing Address</strong></span>
                    <span *ngIf="!license.mailingIsPhysical" class="w-full lg:w-[70%] break-words f-s-16">
                      {{license.mailingStreet}}&nbsp;
                      {{license.mailingCity}}&nbsp;
                      {{license.mailingState}}&nbsp;
                      {{license.mailingZip}}&nbsp;
                      {{license.mailingCounty}}
                    </span>
                    <span  class="w-full lg:w-[70%] f-s-16" *ngIf="license.mailingIsPhysical">Same as physical</span>
                  </div>

                <mat-checkbox [checked]="license.businessInOregon" disabled>
                  <span class="text-wrap f-s-16">Laboratory is registered as a business with the Secretary of State (SOS) in Oregon</span>
                </mat-checkbox>
                <div *ngIf="license.businessInOregon" class="flex flex-col">
                  <span class="f-s-16"><strong>Oregon Secretary of State Registry Number</strong></span>
                  <span class="f-s-16">{{license.secretaryofStateNumber}}</span>
                </div>
                <mat-checkbox [checked]="license.registeredBusiness" disabled *ngIf="!license.businessInOregon">
                  <span class="text-wrap f-s-16">Laboratory is registered as a business in another state, US territory or a freely associated state</span>
                </mat-checkbox>
                <div *ngIf="!license.businessInOregon && license.registeredBusiness " class="flex flex-col">
                  <span class="f-s-16"><strong>Location Registered</strong></span>
                  <span class="f-s-16">{{license.registeredIn}}</span>
                </div>
                <div *ngIf="!license.businessInOregon && license.registeredBusiness " class="flex flex-col">
                  <span class="f-s-16"><strong>Registration Number</strong></span>
                  <span class="f-s-16">{{license.registryNumber}}</span>
                </div>

                <mat-checkbox [checked]="license.previousLicense" disabled>
                  <span class="text-wrap f-s-16">Laboratory has applied for or received any other Oregon Psilocybin licenses</span>
                </mat-checkbox>
                <span class="f-s-16"><strong>Other Licenses</strong></span>
                <span class="f-s-16">{{license.affiliatedLicenses}}</span>
              </div>
            </mat-card-content>
          </mat-card>

          <div class="flex flex-col w-full md:w-1/2">
            <mat-card>
              <mat-card-title>
                <div class="flex flex-col">
                  <span>Current Documents</span>
                  <span *ngIf="!documentsValid" class="text-red-400 f-s-16">Not All Requirements Met</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col">
                  <span class="text-red-400 f-s-16" *ngIf="missingTypes[orelapType]">{{documentTypeReference[orelapType]}} required</span>
                  <span class="text-red-400 f-s-16" *ngIf="missingTypes[premisesType]">{{documentTypeReference[premisesType]}} required</span>
                  <span class="text-red-400 f-s-16" *ngIf="missingTypes[socialEquityType]">{{documentTypeReference[socialEquityType]}} required</span>
                  <span class="text-red-400 f-s-16" *ngIf="missingTypes[premisePictureType]">{{documentTypeReference[premisePictureType]}} required</span>
                  <span class="text-red-400 f-s-16" *ngIf="missingTypes[equityPlanEvaluationType]">{{documentTypeReference[equityPlanEvaluationType]}} required</span>
                </div>
                <div class="flex flex-col gap-2">
                  <div *ngFor="let document of this.license.licenseDocuments" class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                    <div class="flex w-full flex-col md:w-[60%]">
                      <span class="f-s-14 md:hidden"><strong>File</strong></span>
                      <span class="text-indigo-A700 f-s-16 break-words" style="cursor: pointer" (click)="downloadDocument(document.id, document.name)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                    </div>
                    <div class="flex w-full flex-col md:w-[40%] md:justify-start">
                      <span class="f-s-14 md:hidden"><strong>Requirement</strong></span>
                      <div class="flex flex-col f-s-16 break-words">
                        <span *ngFor="let type of document.types">
                          {{documentTypeReference[type]}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <div class="flex flex-col lg:flex-row gap-2">
              <mat-card class="w-full lg:w-1/2">
                <mat-card-title>
                  <span *ngIf="applicantsValid">Individual Applicants/ Licensees</span>
                  <span *ngIf="!applicantsValid" class="text-red-400">Individual Applicants/ Licensees Incomplete</span>
                </mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col">
                    <div *ngFor="let applicant of individualApplicants?.applicants" class="flex flex-row gap-2">
                      <span class="f-s-16">{{applicant.legalFirstName}}</span>
                      <span class="f-s-16">{{applicant.legalMiddleName}}</span>
                      <span class="f-s-16">{{applicant.legalLastName}}</span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card class="w-full lg:w-1/2">
                <mat-card-title>
                  <span *ngIf="entityApplicantsValid">Entity Applicants</span>
                  <span *ngIf="!entityApplicantsValid" class="text-red-400">Entity Applicants Incomplete</span>
                </mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col">
                        <div *ngFor="let applicant of entityApplicants?.applicants" class="flex flex-row gap-2">
                      <span class="f-s-16">{{applicant.entityName}}</span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>

            <mat-card>
              <mat-card-title>
                Sign and Submit
              </mat-card-title>
              <mat-card-content>
                <form [formGroup]="verifyForm">
                  <div class="flex flex-col gap-2 f-s-16">
                    <ul class="flex flex-col gap-2">
                      <li class="f-s-16">
                        I certify the information provided in this application is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial of my application or revocation of my license.
                      </li>
                      <li class="f-s-16">
                        I understand I am responsible for making my own determination regarding the legal risks associated with a Schedule 1 substance under the Federal Controlled Substances Act.
                      </li>
                      <li class="f-s-16">
                        I understand laboratory licenses are only valid for the licensed premises and are only issued to the individuals or entities listed on the application or subsequently approved by the Authority.
                      </li>
                      <li class="f-s-16">
                        I understand the information provided in application materials, including applicant name, is subject to disclosure
                        under Oregon's public records laws and that certain information may be posted on OHA's website for purposes of license verification.
                      </li>
                      <li class="f-s-16">
                        I understand all individual applicants must complete and pass a background check as a condition of licensure.
                      </li>
                      <li class="f-s-16">
                        I understand individual applicants are required to obtain a psilocybin worker permit if they participate in activities outlined in OAR 333-333-4070 (1) (a), (b), (c), (d).
                      </li>
                      <li class="f-s-16">
                        I understand and will adhere to the requirements for Notification of Changes as outlined in OAR 333-333-4200.
                      </li>
                      <li class="f-s-16">
                        I understand Oregon Psilocybin Services will charge a change fee of $250 per inspection for any change to a previously approved license that requires an inspection of the licensed premises. This change fee applies regardless of whether the licensee requests the change at renewal or during the term of their license.
                      </li>
                      <li class="f-s-16">
                        I have read, understand, and agree to adhere to the Oregon Psilocybin Services Revised Statutes (ORS) Chapter 475A, Oregon Administrative Rules (OAR) Chapter 333, Division 333, as well as any other applicable statutes or laws.
                      </li>
                      <li class="f-s-16">
                        I understand that failure to adhere to these statutes and rules may result in my application being denied or disciplinary action taken against any future licenses issued by Oregon Psilocybin Services.
                      </li>
                      <li class="f-s-16">
                        I certify the proposed licensed premise meets the location requirements outlined in OAR 333-333-4300.
                      </li>
                      <li class="f-s-16">
                        I understand a laboratory licensee may not perform any required psilocybin sampling or testing using any sampling or testing methods or equipment not permitted under the laboratory’s accreditation through the Oregon Environmental Laboratory Accreditation Program.
                      </li>
                      <li class="f-s-16">
                        I understand the laboratory license has a term of one year from the effective date of licensure. If I wish to renew the license after that term, a renewal application must be submitted.
                      </li>
                      <li class="f-s-16">
                        I understand a license will not be issued until the license fee payment is paid and cleared. A licensee may not operate until the effective date of licensure.
                      </li>
                      <li class="f-s-16" *ngIf="showRequiredApplicantDataAttestation(license.applicationDate)">
                        Applicant(s) understand and will comply with the requirement to complete and submit the Required 303 Applicant and Licensee REAL & SOGI
                        Data form in accordance with ORS 475A.374.
                      </li>
                      <li class="f-s-16">
                        I understand the laboratory application and annual license fees are non-refundable.
                      </li>
                      <li class="f-s-16" *ngIf="renewing && sharedService.isAfterJan15th2027()">
                        Every product tracking system user for the licensed premises has completed training required by the Authority for the product tracking system.
                      </li>
                      <li class="f-s-16" *ngIf="!renewing && sharedService.isAfterJan15th2027()">
                        Every product tracking system user for the licensed premises will complete training required by the Authority for the product tracking system.
                      </li>
                    </ul>

                    <mat-checkbox formControlName="attestation">
                      <span class="f-s-16" style="white-space: normal;" [ngStyle]="{'color': verifyForm.get('attestation').hasError('required')? 'red' : ''}">I have read and I understand the above statements.</span>
                    </mat-checkbox>

                    <mat-radio-group aria-label="Select an option" formControlName="directoryConsent" style="padding-top: 1em" class="gap-4">
                      <div class="flex flex-col gap-4">
                        <div class="flex flex-row">
                          <mat-radio-button [value]="true">
                            <span class="text-wrap f-s-16">
                              I consent to having my license name, license type, and the contact information selected below listed in the voluntary OPS Licensee Directory.
                            </span>
                          </mat-radio-button>
                        </div>

                        <div style="padding-left: 1em" *ngIf="verifyForm.get('directoryConsent').value" class="flex flex-col">
                          <div class="gap-[5px]">
                            <mat-checkbox formControlName="directoryConsentWebsite">
                              <span id="directoryWebsiteLabel" class="f-s-16" style="white-space: normal;">Website:</span>
                            </mat-checkbox>
                            <mat-form-field *ngIf="verifyForm.get('directoryConsentWebsite').value">
                              <mat-label class="f-s-16">
                                Website
                              </mat-label>
                              <input matInput formControlName="directoryWebsite" aria-describedby="directoryWebsiteLabel">
                              <mat-error role="alert">
                                <span *ngIf="verifyForm.get('directoryWebsite').hasError('required')">Error: Directory website URL is required</span>
                                <span *ngIf="verifyForm.get('directoryWebsite').hasError('pattern')">Error: Please enter a valid URL (http:// or https://)</span>
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="gap-[5px]">
                            <mat-checkbox formControlName="directoryConsentEmail">
                              <span id="directoryEmailLabel" class="f-s-16" style="white-space: normal;">Email:</span>
                            </mat-checkbox>
                            <mat-form-field *ngIf="verifyForm.get('directoryConsentEmail').value">
                              <mat-label class="f-s-16">
                                Email
                              </mat-label>
                              <input matInput formControlName="directoryEmail" aria-describedby="directoryEmailLabel">
                              <mat-error role="alert" *ngIf="validateDirectoryConsentEmail()">
                                Error: This field is required
                              </mat-error>
                            </mat-form-field>
                          </div>

                          <div class="gap-[5px]">
                            <mat-checkbox formControlName="directoryConsentPhone">
                              <span id="directoryPhoneLabel" class="f-s-16" style="white-space: normal;">Phone Number:</span>
                            </mat-checkbox>
                            <mat-form-field *ngIf="verifyForm.get('directoryConsentPhone').value">
                              <mat-label class="f-s-16">
                                Phone number
                              </mat-label>
                              <input matInput formControlName="directoryPhone" mask="(000) 000-0000 000000" aria-describedby="directoryPhoneLabel">
                              <mat-error role="alert" *ngIf="validateDirectoryConsentPhone()">
                                Error: This field is required
                              </mat-error>
                            </mat-form-field>
                          </div>
                        </div>

                        <div class="flex flex-row">
                          <mat-radio-button [value]="false">
                            <span class="text-wrap f-s-16">
                              I <strong>do not</strong> consent to having my license name, license type, and contact information listed in the voluntary OPS Licensee Directory.
                            </span>
                          </mat-radio-button>
                        </div>
                      </div>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="verifyForm.get('directoryConsent').invalid">Error: You must select one statement regarding consent</mat-error>
                    <span class="text-wrap f-s-16">Please note, if you do not consent, you may still be licensed with Oregon Psilocybin Services.</span>

                    <div class="flex flex-col lg:flex-row gap-2 justify-start items-center">
                      <mat-form-field class="lg:!w-1/3 w-full">
                        <mat-label class="f-s-16">
                          Signature
                        </mat-label>
                        <input matInput placeholder="Signature" formControlName="electronicSignature">
                        <mat-error role="alert" *ngIf="verifyForm.get('electronicSignature').invalid">
                          Error: Signature is required
                        </mat-error>
                      </mat-form-field>
                       <button [disabled]="!applicationValid() || !verifyForm.valid && !licenseLocked || validateDirectoryConsentWebsite()"
                        type="submit" mat-flat-button color="primary" (click)="submitApplication()">Submit</button>
                    </div>
                  </div>
                </form>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>

      <div class="p-t-16 flex flex-row gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>Back</button>
      </div>
    </mat-step>

  </mat-stepper>
</div>

<div *ngIf="!viewForm && !showSubmitted">
  <div class="flex flex-col gap-2">
    <div>
      <button mat-flat-button type="button" *ngIf="showStartButton" color="primary" (click)="startApplication()">Start New Application</button>
    </div>
    <div *ngFor="let license of licenses">
      <mat-card [style.background]="cardColor" class="w-full">
        <mat-card-content>
          <div class="flex 2xl:flex-row flex-col gap-2">
            <mat-card class="w-full lg:w-[70%]">
              <mat-card-title>
                <div class="flex flex-row gap-4">
                  <span>Laboratory</span>
                  <span>{{license.entityName}}</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col lg:flex-row gap-6">
                  <div class="flex flex-col gap-2 flex-1">
                    <div class="m-b-0 flex flex-row justify-start items-center">
                      <span class="w-[40%] lg:w-[30%] f-s-16"><strong>Laboratory Id</strong></span>
                      <span class="f-s-16" id="programId">{{license.licenseId}}</span>
                      <button mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId)" color="primary"
                              matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                    </div>
                    <div class="flex flex-row justify-start items-center">
                      <span class="w-[40%] lg:w-[30%] f-s-16"><strong>Status</strong></span>
                      <div class="flex flex-col">
                        <span class="f-s-20 f-w-700" [ngClass]="license.status === sharedService.approved? 'text-light-green-600':
                                        (license.status === sharedService.submitted ||
                                         license.status === sharedService.pending ||
                                         license.status === sharedService.awaitingPayment ||
                                         license.status === sharedService.underReview)? 'text-orange-900' : 'text-red-900'" *ngIf="license.status != sharedService.submittedForApproval && license.status != sharedService.renewalSubmittedForApproval">
                          {{license.status}}
                      </span>
                      <span class="f-s-20 f-w-700" [ngClass]="'text-orange-900'" *ngIf="license.status == sharedService.submittedForApproval || license.status == sharedService.renewalSubmittedForApproval">{{sharedService.underReview}}</span>
                      </div>
                    </div>
                    <div *ngIf="license.status === sharedService.submitted || (license.status === sharedService.closed && license.applicationDate)" class="flex flex-row">
                      <span class="w-[40%] lg:w-[30%] f-s-16"><strong>Date Submitted</strong></span>
                      <span class="f-s-16">{{license.applicationDate | date}}</span>
                    </div>
                    <div *ngIf="license.status === sharedService.closed" class="flex flex-row">
                      <span class="w-[40%] lg:w-[30%] f-s-16"><strong>Closed Date</strong></span>
                      <span class="f-s-16">{{license.closedDate | date}}</span>
                    </div>
                    <div *ngIf="license.status === sharedService.approved" class="flex flex-row">
                      <span class="w-[40%] lg:w-[30%] f-s-16"><strong>Date Approved</strong></span>
                      <span class="f-s-16">{{license.approvedDate | date}}</span>
                    </div>
                    <div *ngIf="license.status === sharedService.approved || license.status === sharedService.expired" class="flex flex-row">
                      <span class="w-[40%] lg:w-[30%] f-s-16"><strong>Expiration Date</strong></span>
                      <span class="f-s-16">{{license.expirationDate | date}}</span>
                    </div>
                    <div *ngIf="license.status === sharedService.approved && license.isRenewal" class="flex flex-row">
                      <span class="w-[40%] lg:w-[30%] f-s-16"><strong>Date Renewal Approved</strong></span>
                      <span class="f-s-16">{{license.renewedDate | date}}</span>
                    </div>

                  </div>
                  <div class="flex flex-col gap-2 justify-start items-start">
                    <button *ngIf="license.status !== sharedService.pendingRenewal && license.status !== sharedService.renewalSubmitted && !license.isRenewal"
                      mat-flat-button type="button" color="primary" (click)="viewApplication(license)">
                      <div *ngIf="loadingIndex[license.id]" class="flex flex-row gap-2">
                        <span>Loading</span>
                        <mat-spinner color="accent" [diameter]="25" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
                      </div>
                      <span *ngIf="!loadingIndex[license.id] && license.status != 'Pending'">View</span>
                      <span *ngIf="!loadingIndex[license.id] && license.status == 'Pending'">Edit</span>
                    </button>
              <button *ngIf="license.isRenewal"
                mat-flat-button type="button" color="primary" (click)="viewRenewal(license)">
                <div *ngIf="loadingIndex[license.id]" class="flex flex-row gap-2">
                  <span>Loading</span>
                <mat-spinner color="accent" [diameter]="25" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
              </div>
              <span *ngIf="license.status === sharedService.pendingRenewal && !loadingIndex[license.id]">Continue Renewal</span>
              <span *ngIf="license.status !== sharedService.pendingRenewal">View</span>
              </button>
            <button *ngIf="license.canRenew && !hasRenewal(license) && license.status == sharedService.approved && !startedRenewal"
              mat-flat-button type="button" color="primary" (click)="createRenewal(license)">
              <span>Start Renewal</span>
            </button>
                    <button *ngIf="license.status == 'Submitted'" mat-flat-button type="button" color="accent"
                      (click)="requestWithdraw(license)">Request Withdraw
                    </button>
                    <button *ngIf="license.status == 'Approved'" mat-flat-button type="button" color="accent"
                      (click)="requestSurrender(license)">Request Surrender
                    </button>
                    <!-- <button *ngIf="license.status !== sharedService.withdrawn && license.status !== sharedService.closed"
                            mat-flat-button type="button" color="warn" (click)="withdrawApplication(license)">
                      <span *ngIf="license.status === sharedService.submitted || license.status === sharedService.underReview">Request Withdrawal</span>
                      <span *ngIf="license.status !== sharedService.submitted && license.status !== sharedService.underReview">Withdraw</span>
                    </button> -->
                    <a *ngIf="licenseHasUnpaidFees(license)" mat-flat-button type="button" color="warn" routerLink="/payments">Pay Fees</a>
                    <button *ngIf="license.status == 'Approved'" color="primary" mat-flat-button type="button" (click)="viewPrintScreen(license)">Print License</button>
                    <button *ngIf="license.status == 'Approved'" color="primary" mat-flat-button type="button" (click)="changeDirectory(license)">
                      <span class="text-wrap">Change OPS Licensee Directory Consent</span>
                    </button>
                  </div>
                </div>

                <div class="m-t-8 flex flex-col lg:flex-row">
                  <div class="flex flex-col w-full lg:w-1/2">
                    <div class="flex flex-row w-full">
                      <span class="w-1/2"><strong>Application Fee Status</strong></span>
                      <span [ngClass]="hasPaidFee(license, paymentService.applicationFeeType) ? 'text-light-green-600':  'text-red-900'">
                        <span class="f-s-16">{{getPaymentFeeStatus(license, paymentService.applicationFeeType)}}</span>
                      </span>
                    </div>

                    <div *ngIf="hasPaidFee(license, paymentService.applicationFeeType)" class="flex flex-row w-full">
                      <span class="w-1/2"><strong>Application Fee Cleared</strong></span>
                      <span class="f-s-16">{{getFeeCleared(license, paymentService.applicationFeeType)}}</span>
                    </div>
                  </div>

                  <div class="flex flex-col w-full lg:w-1/2">
                    <div class="flex flex-row w-full">
                      <span class="w-1/2"><strong>License Fee Status</strong></span>
                      <span [ngClass]="hasPaidFee(license, paymentService.licenseFeeType) ? 'text-light-green-600':  'text-red-900'">
                        <span class="f-s-16">{{getPaymentFeeStatus(license, paymentService.licenseFeeType)}}</span>
                      </span>
                    </div>

                    <div *ngIf="hasPaidFee(license, paymentService.licenseFeeType)" class="flex flex-row w-1/2">
                      <span class="w-1/2"><strong>License Fee Cleared</strong></span>
                      <span class="f-s-16">{{getFeeCleared(license, paymentService.licenseFeeType)}}</span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card *ngIf="license.status === sharedService.approved" class="w-full lg:w-[30%]">
              <mat-card-title>
                <div class="flex flex-row gap-2">
                  <span class="flex-1">TLC-PTS (Product Tracking) Worker Permits</span>
                  <button mat-button type="button" color="primary" (click)="addWorkerPermit(license)">Add Permits</button>
                </div>
                <div class="flex flex-col gap-2">
                  <span class="f-s-16"><strong>•</strong> Click Add Permits to give access to permitted workers to add, change and delete data for the <strong>TLC-PTS (Product Tracking)</strong> account for this license.</span>
                  <span class="f-s-16"><strong>•</strong> If the license holder will be updating TLC-PTS, add their worker permit also.</span>
                  <br/>
                  <span class="f-s-16" style="padding-left: 2%; text-decoration: underline;">Added Worker Permits</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div *ngFor="let permit of license.workerPermits" class="flex flex-col gap-2 rounded border border-solid border-gray-300 p-3 md:flex-row md:items-start md:justify-between">
                    <div class="min-w-0 flex-1">
                      <div class="f-s-16 break-words">
                        <strong>{{ permit.applicants[0].legalFirstName }} {{ permit.applicants[0].legalMiddleName }} {{ permit.applicants[0].legalLastName }}</strong>
                      </div>
                      <div class="f-s-14 break-words text-gray-700">
                        Worker Permit ID: {{ permit.licenseId }}
                      </div>
                    </div>
                    <div class="flex justify-start md:justify-end">
                      <button mat-flat-button type="button" color="warn" (click)="removeWorkerPermit(license, permit.licenseId)">Remove</button>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<div *ngIf="showSubmitted">
  <mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.orange">
    <mat-card-content>
      <div style="color: #303030" class="flex flex-row gap-2 justify-start items-center">
        <mat-icon class="medium-icon m-24">domain</mat-icon>
        <span class="f-s-20 flex-1" *ngIf="!renewing">Laboratory Application Submitted</span>
        <span class="f-s-20 flex-1" *ngIf="renewing">Laboratory Application Renewal Submitted</span>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!renewing">
    <mat-card-content>
      <span class="f-s-16">Thank you for submitting the Oregon Psilocybin Services laboratory license application.
        You can review your application status and updates to the status in TLC. Please be sure to monitor your email
        for follow-up communication from the Oregon Psilocybin Services Licensing Team. To ensure you receive emails from OPS,
        please consider adding Licensing.Psilocybin&#64;oha.oregon.gov to your email contacts to prevent the email going to your spam folder. </span>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="renewing">
    <mat-card-content>
      <span class="f-s-16">Thank you for submitting the Oregon Psilocybin Services laboratory license renewal application.
        You can review your application status and updates to the status in TLC. Please be sure to monitor your email
        for follow-up communication from the Oregon Psilocybin Services Licensing Team. To ensure you receive emails from OPS,
        please consider adding Licensing.Psilocybin&#64;oha.oregon.gov to your email contacts to prevent the email going to your spam folder. </span>
    </mat-card-content>
  </mat-card>

  <app-payment-notice *ngIf="license != null && license.payments != null && licenseHasUnpaidFees(license)"
    feeType="ApplicationFee" entityType="TestingLabLicense" [canPay]="true" [id]="license.id">
  </app-payment-notice>

  <div class="m-t-16 flex flex-row gap-4">
    <button mat-raised-button  type="button" (click)="continue()">Continue</button>
  </div>
</div>

<div *ngIf="loadingTestingLab">
  <div [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h2>Loading</h2>
  </div>
</div>
